module.exports = __webpack_public_path__ + "img/icon_qe.77061ce9.png";